import {
  SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN,
  SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_SUCCESS,
  SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_ERROR,
  SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetDashboardDetailsCSRFToken = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_DASHBOARD_DETAILS_CSRF_TOKEN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetDashboardDetailsCSRFToken;
